import React, { useState } from "react";
import { Modal } from "../../../../../components/modal/index";
import { FeedbackModalContainer } from "./style";
import { formatDate } from "../../../../../lib/normalizeDate";
import ImageSlider from "../../../../../components/imageSlider";

const FeedbackModal = ({ showModal, data, closeHandler, sendScore }) => {
  const [rate, setRate] = useState(data.feedback_response.score);
  const sendScoreHandle = (e, id, score, currentScore) => {
    // console.log(id, score, currentScore);
    e.stopPropagation();
    if (score + 1 !== currentScore) {
      setRate(score + 1);
      sendScore(id, score + 1);
    }
  };

  const renderScore = (score, id) => {
    let ratedStars = [];
    let unRatedStars = [];
    let ratedNum = 0;
    for (let i = 0; i < 5; i++) {
      if (ratedNum < score)
        ratedStars.push(
          <i
            className="selected icon mapsa-filled-favourites-star"
            key={i}
            onClick={e => sendScoreHandle(e, id, i, score)}
          />
        );
      else
        unRatedStars.push(
          <i
            className="unselected icon mapsa-favourites-star"
            key={i}
            onClick={e => sendScoreHandle(e, id, 5 + score - 1 - i, score)}
          />
        );
      ratedNum += 1;
    }
    return (
      <div className="rating">
        {ratedStars}
        <div className="unrated-stars">{unRatedStars}</div>
      </div>
    );
  };
  return (
    <FeedbackModalContainer>
      <Modal
        show={showModal}
        closeHandler={closeHandler}
        body={
          <div className="response-modal-body-container">
            <div className="response-modal-date">
              {formatDate(data.created_at)}
            </div>
            <div className="response-modal-subject">
              {data.feedback_title.title}
            </div>
            <div className="response-modal-title">
              {data.text.split("\n").join("\n")}
            </div>
            <div className="images">
              {data.images.length !== 0 && <i className="icon mapsa-clip" />}
              <ImageSlider files={data.images} whitOutProject />
            </div>
            <div className="response-modal-description">
              {data.feedback_response.text}
            </div>
            <div className="images">
              {data.feedback_response.images &&
                data.feedback_response.images.length !== 0 && (
                  <i className="icon mapsa-clip" />
                )}
              <ImageSlider
                files={data.feedback_response.images}
                whitOutProject
              />
            </div>
            <div className="response-modal-rate-section">
              {renderScore(rate, data.id)}
            </div>
            <div className="response-modal-answer-info">
              <div className="ans-date">
                تاریخ پاسخ: {formatDate(data.feedback_response.created_at)}
              </div>
              <div className="ans-name">
                {" "}
                پاسخ توسط {data.feedback_response.panel_user.name}
              </div>
            </div>
          </div>
        }
        loading={false}
        header={{
          title: "",
          icon: "icon mapsa-feedback",
          iconColor: "primary_vivid"
        }}
      />
    </FeedbackModalContainer>
  );
};

export default FeedbackModal;
